// extracted by mini-css-extract-plugin
export default {"custom-chip":"CustomChip_custom-chip__Y8rZI"};